import { Controller } from "@hotwired/stimulus";

/**
 * Auto-fills the list name field based on the selected item type.
 * Finds the select and input by their Rails form name attributes.
 *
 * Usage:
 *   <div data-controller="tiered-list-name-default">
 *     <!-- Primer form fields rendered inside -->
 *   </div>
 */
export class TieredListNameDefaultController extends Controller {
  connect() {
    this.typeSelect = this.element.querySelector(
      '[name="tiered_list_node[item_type_id]"]'
    );
    this.nameInput = this.element.querySelector(
      '[name="tiered_list_node[name]"]'
    );

    if (this.typeSelect) {
      this.typeSelect.addEventListener("change", this.updateName.bind(this));
    }
  }

  disconnect() {
    if (this.typeSelect) {
      this.typeSelect.removeEventListener("change", this.updateName.bind(this));
    }
  }

  updateName() {
    if (!this.nameInput) return;

    // Only auto-fill if the name is empty or was previously auto-filled
    if (this.nameInput.value && !this.nameInput.dataset.autoFilled) return;

    const selectedOption =
      this.typeSelect.options[this.typeSelect.selectedIndex];

    if (selectedOption && selectedOption.value) {
      this.nameInput.value = selectedOption.text;
      this.nameInput.dataset.autoFilled = "true";
    } else {
      this.nameInput.value = "";
      delete this.nameInput.dataset.autoFilled;
    }
  }
}
